import httpClient from "./httpClient";

const MemberStatusService = {
  async findAll(page, pageSize) {
    return await httpClient.get("/member-status", {
      params: { page, pageSize }
    });
  },

  async getAll() {
    return await httpClient.get("/member-status/get-all");
  },

  async findById(id) {
    return await httpClient.get(`/member-status/${id}`);
  },

  async create(entity) {
    return await httpClient.post("/member-status", entity);
  },

  async update(entity) {
    return await httpClient.put("/member-status", entity);
  }
};

export default MemberStatusService;
